import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import BaseForm from 'containers/Base/BaseForm';
import { PAGE_URLS } from 'utils/constants';
import {
  regionDetailSection,
  regionGeneralSection,
  regionInitialState,
  validationSchema,
} from 'containers/Pages/Region/Region/Layouts/regionFormLayoutHelper';
import timezones from 'static/timezones.json';
import services_suite from 'static/services.json';
import {
  regionActions,
  regionSelectors,
} from 'containers/Pages/Region/Region/index';

const RegionFrom = ({ editMode, closeForm }) => {
  const regionDetails = useSelector(state =>
    regionSelectors.getApiRegionDetails(state),
  );

  const dispatch = useDispatch();
  const onEdit = values => {
    //create the payload
    const {
      context,
      consequence,
      likelihood,
      description,
      defaultRecommendation,
    } = values;
    const currentRisk = {
      context,
      consequence,
      likelihood,
      description,
      defaultRecommendation,
    };
    const boundary = {
      points: values?.locations[0].paths.map(p => {
        return {
          latitude: p.lat,
          longitude: p.lng,
        };
      }),
    };
    const region = { ...values, currentRisk, boundary };
    dispatch(regionActions.updateRowEntry({ region }));
  };
  const onCreate = values => {
    //create the payload
    const {
      context,
      consequence,
      likelihood,
      description,
      defaultRecommendation,
    } = values;
    const currentRisk = {
      context,
      consequence,
      likelihood,
      description,
      defaultRecommendation,
    };
    const boundary = {
      points: values?.locations[0].paths.map(p => {
        return {
          latitude: p.lat,
          longitude: p.lng,
        };
      }),
    };
    const region = { ...values, currentRisk, boundary };
    dispatch(regionActions.createRowEntry({ region }));
  };
  return (
    <BaseForm
      formTitle={editMode ? 'Edit Region' : 'Create Region'}
      imageRequired={false}
      edit={editMode}
      initialValues={editMode ? regionDetails : regionInitialState()}
      validationSchema={validationSchema}
      //form layout
      generalSection={regionGeneralSection({
        services: services_suite,
        timezones,
      })}
      detailedSection={regionDetailSection()}
      //form actions
      closeForm={closeForm}
      onSubmit={editMode ? onEdit : onCreate}
      //persistence (save when leaving/coming back)
      persistentStateName={PAGE_URLS.REGION.name}
    />
  );
};
RegionFrom.propTypes = {
  editMode: PropTypes.bool,
  closeForm: PropTypes.func,
  id: PropTypes.string,
  persistentStateName: PropTypes.string,
  createRegion: PropTypes.func,
  editRegion: PropTypes.func,
  details: PropTypes.object,
};
export default RegionFrom;
